import { initReactI18next } from 'react-i18next'

import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

import { Languages } from './languages'
import { translationsToJson } from './mapping'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(
    {
      lng: 'en',
      resources: {
        en: {
          translations: translationsToJson(Languages.en)
        }
      },
      fallbackLng: Languages.en,
      ns: ['translations'],
      defaultNS: 'translations',
      debug: true,
      interpolation: {
        escapeValue: false,
        formatSeparator: ','
      },
      returnNull: false,
      react: { useSuspense: true }
    },
    (error) => {
      if (error) {
        return console.log('Loading i18n error', error)
      }
    }
  )
i18n.loadLanguages(['en'], () => {})
i18n.language = 'en'
document.documentElement.lang = 'en'

export default i18n
